// query-client.ts — configured TanStack QueryClient.
// Retries are skipped for 4xx responses (client errors are terminal).

import { QueryClient } from '@tanstack/react-query';

import type { ApiError } from './api-error';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const status = (error as Partial<ApiError> | undefined)?.status;
        if (typeof status === 'number' && status >= 400 && status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
